import {createAction} from "redux-act";

export const showErrorModal = createAction<string>();
export const hideErrorModal = createAction();

export const toggleTutorialModal = createAction<boolean>();
export const toggleGameOverModal = createAction<boolean>();

export const setIsTutorialViewed = createAction<boolean>();
export const closeMaintenanceModal = createAction<boolean>();
